<div *ngIf="addUserMaster === true">
    <pageheader [entity]="headerAddUser"></pageheader>
    <div *ngIf="listView" class="top-btns">
        <div class="table-outer">
            <grid [entities]="adduser" [checkboxCol]="true" [entityColumns]="adduserColumns" [selectionField]="'UserId'"
                [actionExclude]="['feedback']" [addEntityIcon]="'bi bi-plus-square'" [addEntityCaption]="'Add'"
                [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()" (addEntity)="addUser($event)"
                (editEntity)="edituser($event)" (refreshEntities)="refreshuser($event)"
                (deleteEntity)="deleteuser($event)"></grid>
        </div>
    </div>
    <div *ngIf="!listView">
        <div class="report top-btns">
            <div class="form-caption-nav">
                {{ formCaption }}
            </div>
            <nav class="navbar-expand-md navbar-white navbar-form bg-light  mt-2">
                <ul class="navbar-nav justify-content-end">

                    <li class="nav-item">
                        <a class="nav-link" (click)="clearuser()"><i class="bi bi-slash-circle"></i>Clear</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" (click)="revertChanges()"><i class="bi bi-arrow-clockwise"></i>Revert
                            Changes</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" (click)="gotoBack()"><i class="bi bi-arrow-left-circle"></i>Go Back</a>
                    </li>
                </ul>
            </nav>
            <div class="form-body">
                <div class="row">
                    <!-- <div class="col-md-4">
                        <div class="mb-3">
                            <textbox [caption]="'User id'" [mandatory]="true" [formData]="entity"
                                [fieldName]="'UserId'" [(ngModel)]="entity.UserId" ngDefaultControl></textbox>
                        </div>
                    </div> -->
                    <div class="col-md-4">
                        <div class="mb-3">
                            <textbox [caption]="'User Name'" [mandatory]="true" [formData]="entity" [maxlength]="100"
                                [fieldName]="'UserName'" [(ngModel)]="entity.UserName" ngDefaultControl></textbox>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="mb-3">
                            <label>Password<span style="color: red">*</span></label>
                            <input type="Password" [(ngModel)]="entity.PasswordHash" placeholder="Password"
                                class="form-control" required (change)="checkValidPassword()">
                        </div>
                    </div>
                    

                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-3">
                            <dropdown [caption]="'User Type'" [mandatory]="true" [data]="type" [formData]="entity"
                                 [textField]="'User_Type_Name'"
                                [valueField]="'UserTypeId'" [selectedItem]="selectrole" [(ngModel)]="entity.UserTypeId"
                                ngDefaultControl></dropdown>
                        </div>
                    </div>
                     
                     
                    <div class="col-md-4" >
                        <div class="mb-3" >
                            <textbox [caption]="'Branch'" [maxlength]="100" [formData]="entity"
                            [fieldName]="'LocationName'" [(ngModel)]="entity.LocationName" [disabled]="true" ngDefaultControl>
                            </textbox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="mb-3">
                            <textbox [caption]="'Email id'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                                [fieldName]="'Email'" [(ngModel)]="entity.Email" ngDefaultControl>
                            </textbox>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="mb-3">
                            <textbox [caption]="'PhoneNumber'" [mandatory]="true" [maxlength]="10" [formData]="entity"
                                [fieldName]="'PhoneNumber'" (keypress)="numberOnly($event)"
                                [(ngModel)]="entity.PhoneNumber" ngDefaultControl></textbox>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="row mb-2 mt-3">

                            <div class="col-md-12">
                                <!-- <div class="k-multiselect-wrap k-floatwrap"> -->
                                    <label>User Role<span style="color: red">*</span></label>
                                <kendo-multiselect [data]="role" [filterable]="true" [textField]="'Role_Name'"
                                    [valueField]="'Role_Id'" [placeholder]="'Select Role'"
                                    [(ngModel)]="entity.Role_Id" ngDefaultControl></kendo-multiselect>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- <div class="table-outer">
                    <grid [entities]="entity.UserRoles" [checkboxCol]="false" [entityColumns]="entityColumns"
                        [showActions]="false" [pageSize]="4">
                    </grid>
                </div> -->

                <div class="row">
                    <div class="mt-3">
                        <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'"
                        [disabled]="saveDisabled" [type]="'button'"></btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="addUserMaster === false">
    <div class="row">
        <div class="col-md-4">
            <div class="mb-3">
                <textbox [caption]="'User Name'" [mandatory]="true" [formData]="entity" [maxlength]="100"
                    [fieldName]="'UserName'" [(ngModel)]="entity.UserName" ngDefaultControl></textbox>
            </div>
        </div>

        <div class="col-md-4">
            <div class="mb-3">
                <label>Password<span style="color: red">*</span></label>
                <input type="Password" [(ngModel)]="entity.PasswordHash" placeholder="Password" class="form-control"
                (change)="checkValidPassword()"  required>
            </div>
        </div> 
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="mb-3">
                <dropdown [caption]="'User Type'" [mandatory]="true" [data]="type" [formData]="entity"
                     [textField]="'User_Type_Name'" [valueField]="'UserTypeId'"
                    [selectedItem]="selectrole" [(ngModel)]="entity.UserTypeId" ngDefaultControl></dropdown>
            </div>
        </div>
     

        <div class="col-md-4" *ngIf="showBranch">
            <div class="mb-3">
                <textbox [caption]="'Location'" [maxlength]="100" [formData]="entity"
                            [fieldName]="'LocationName'" [(ngModel)]="entity.LocationName" [disabled]="true" ngDefaultControl>
                            </textbox>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="mb-3">
                <textbox [caption]="'Email id'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                     [(ngModel)]="entity.Email" ngDefaultControl>
                </textbox>
            </div>
        </div>

        <div class="col-md-4">
            <div class="mb-3">
                <textbox [caption]="'Phone Number'" [mandatory]="true" [maxlength]="10" [formData]="entity"
                     (keypress)="numberOnly($event)" [(ngModel)]="entity.PhoneNumber"
                    ngDefaultControl></textbox>
            </div>
        </div>
        <div class="col-md-4">
            <div class="row mb-2 mt-3">
                <div class="col-md-12">
                    <label>User Role<span style="color: red">*</span></label>
                    <!-- <div class="k-multiselect-wrap k-floatwrap"> -->
                        <kendo-multiselect [data]="role" [filterable]="true" [textField]="'Role_Name'"
                            [valueField]="'Role_Id'" [placeholder]="'Select Role'" [(ngModel)]="entity.Role_Id"
                            ngDefaultControl></kendo-multiselect>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <grid [entities]="entity.UserRoles" [checkboxCol]="false" [entityColumns]="entityColumns"
                [showActions]="false" [pageSize]="4">
            </grid>
        </div> -->
        <div class="row">
            <div class="mt-3">
                <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'"
                    [type]="'button'">
                </btn>
            </div>
        </div>
    </div>


    <!-- <ng-template #typeApproval let-dataItem let-rowIndex="rowIndex">
        <dropdown [data]="typeApprovalList" [placeholder]="'Type'" [valueField]="'Value_Id'" [textField]="'Text_Value'"
            [(ngModel)]="dataItem.Role_Id" [selectedItem]="dataItem.selectedAppType" [mandatory]="true"
            [filterable]="true" ngDefaultControl>
        </dropdown>
    </ng-template>
    <ng-template #approved let-dataItem let-rowIndex="rowIndex">
        <btn [label]="''" [class]="'bi bi-plus-circle'" [type]="'button'" (click)="goNext(rowIndex)"></btn>

        <btn [label]="''" [class]="'bi bi-x-circle'"
            *ngIf="(dataItem.Role_Id > 0 )|| ( dataItem.Role_Id === 0 && rowIndex!==dataItem.Role_Id.length-1) ||(dataItem.Role_Id === 0) "
            [type]="'button'" (click)="goPrevious(rowIndex)"></btn>
    </ng-template> -->

    <kendo-excelexport [data]="adduser" [collapsible]="true" fileName="adduser.xlsx" #excelexport>
        <kendo-excelexport-column field="UserId" title="UserId" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="UserName" title="User Name" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="DisplayName" title="Display Name" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="Role_Name" title="Role Name" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="Emp_Name" title="Employee Name" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="Entity_Name" title="Entity Name" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="Email" title="Email" [width]="200">
        </kendo-excelexport-column>
        <kendo-excelexport-column field="PhoneNumber" title="Phone Number" [width]="200">
        </kendo-excelexport-column>
    </kendo-excelexport>